import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormFieldBaseComponent } from '../form-field-base.component';

@Component({
    selector: 'lib-switch-toggle',
    templateUrl: './form-field-switch.component.html',
    styleUrl: './form-field-switch.component.scss'
})
export class FormFieldSwitchComponent extends FormFieldBaseComponent<boolean, FormControl<boolean>> implements AfterViewInit {

    @ViewChild('switch', { read: ElementRef }) element!: ElementRef;

    readonly lock ='M17.7852 7.5L16.5 7.5V5.78571C16.5 3.42 14.3654 1.5 11.9997 1.5C9.63401 1.5 7.5 3.42 7.5 5.78571V7.5L6.21429 7.5C5.27143 7.5 4.5 8.27143 4.5 9.21429V17.7857C4.5 18.7286 5.27143 19.5 6.21429 19.5H17.7852C18.7281 19.5 19.4995 18.7286 19.4995 17.7857V9.21429C19.4995 8.27143 18.7281 7.5 17.7852 7.5ZM11.9997 15.2143C11.0569 15.2143 10.2854 14.4429 10.2854 13.5C10.2854 12.5571 11.0569 11.7857 11.9997 11.7857C12.9426 11.7857 13.714 12.5571 13.714 13.5C13.714 14.4429 12.9426 15.2143 11.9997 15.2143ZM9.21429 7.5V5.78571C9.21429 4.36286 10.5769 3.21429 11.9997 3.21429C13.4226 3.21429 14.7857 4.36286 14.7857 5.78571V7.5H9.21429Z';

    private _disabled: boolean = false;
    @Input()
    set disabled(value: boolean) {
        this._disabled = value;
        if (this._disabled) {
            this.viewControl.disable();
        } else {
            this.viewControl.enable();
        }
    }

    private _checked: boolean = false;
    @Input()
    set checked(value: boolean) {
        this._checked = value;
        this.viewControl.setValue(value);
    }

    @Input() isLockable: boolean = true;

    @Input('isOptional') isOptionalOverride: boolean = false;

    private _toolTipText!: string;
    private _toolTipTextToShow!: string;
    @Input()
    set toolTipText(value: string) {
        this._toolTipText = value;
    }

    @Output() clicked: EventEmitter<void> = new EventEmitter();

    private _initialized: boolean = false;
    private _iconOff!: HTMLElement;
    private _iconOn!: HTMLElement;
    private _iconOffDefault!: string | null;
    private _iconOnDefault!: string | null;

    constructor() {
        super();
        this.viewControl = new FormControl(this._checked, {nonNullable: true});
        this.viewControl.registerOnDisabledChange((disabled: boolean) => {
            if (!disabled && this._initialized) {
                this._toolTipTextToShow = '';
                this._iconOff?.setAttribute('d', this._iconOffDefault!);
                this._iconOn?.setAttribute('d', this._iconOnDefault!);
            } else if (disabled && this._initialized) {
                this._toolTipTextToShow = this._toolTipText;
                this._iconOff?.setAttribute('d', this.lock);
                this._iconOn?.setAttribute('d', this.lock);
            }
        });
    }

    ngAfterViewInit(): void {
        if (this.isLockable && this.element && this.viewControl.disabled) {
            this._iconOff = this.element.nativeElement.querySelector('.mdc-switch__icon--off').firstChild;
            this._iconOffDefault = this._iconOff.getAttribute('d');
            this._iconOff.setAttribute('d', this.lock);
            this._iconOff!.parentElement!.addEventListener('click', () => {
                this.Clicked();
            });
            this._iconOn = this.element.nativeElement.querySelector('.mdc-switch__icon--on').firstChild;
            this._iconOnDefault = this._iconOn.getAttribute('d');
            this._iconOn.setAttribute('d', this.lock);
            this._iconOn!.parentElement!.addEventListener('click', () => {
                this.Clicked();
            });
            this._toolTipTextToShow = this._toolTipText;
        }
        this._initialized = true;
    }

    ChangeEvent(event: MatSlideToggleChange) {
        this.formControl.setValue(event.checked);
        this.SetFormControlValue(event.checked);
        super.OnBlur();
    }

    Clicked(): void {
        if (this.isLockable && this.viewControl.disabled) {
            this.clicked.emit();
        }
    }

    get toolTipText(): string {
        return this._toolTipTextToShow;
    }

}
